import listTemplate from './list/list.pug';
import formTemplate from './form/form.pug';
import viewTemplate from './view/view.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group.view.settings.groupAttributeType', {
    // /context/:ctxId/groups/:groupId/groupattributes
    // :ctxId = ancestor/context group, :groupId = group
      url: '/groupattributetypes',
      abstract: true,
      template: '<ui-view />'
    })
    .state('group.view.settings.groupAttributeType.list', {
      url: '',
      template: listTemplate,
      controller: 'GrpAtrTypeListCtrl',
      controllerAs: 'gavm',
      authenticate: true
    })
    .state('group.view.settings.groupAttributeType.new', {
      url: '/new',
      template: formTemplate,
      controller: 'GrpAtrTypeFormCtrl',
      controllerAs: 'gavm',
      authenticate: true
    })
    .state('group.view.settings.groupAttributeType.view', {
      url: '/:ptId',
      template: viewTemplate,
      controller: 'GrpAtrTypeViewCtrl',
      controllerAs: 'gavm',
      authenticate: true
    })
    .state('group.view.settings.groupAttributeType.edit', {
      url: '/:ptId/edit',
      template: formTemplate,
      controller: 'GrpAtrTypeFormCtrl',
      controllerAs: 'gavm',
      authenticate: true
    });
}];
